module.exports = __webpack_public_path__ + "about_bg.52ed8b9a.png";